export default __webpack_public_path__ + "static/media/skruna.97875abf.svg";